import RportIncidentsImageSlider from "./RportIncidentsImageSlider";

interface Props {
  img_url: string | null;
w_id:string | null;
}

interface Slide {
  url: string;
  title: string;
}

const ReportIncidentsShowSlider: React.FC<Props> = ({ img_url, w_id }) => {

  const base_url = "https://mobile.mobilise-project.org.uk/mobisense/RPCUPLOADS/";



const slides: Slide[] = [];

  const addDynamicSlides = () => {
    if (img_url && w_id) {
      const filenames = img_url.split(",");
      filenames.forEach((filename, index) => {
        slides.push({
          url: `${base_url}${w_id}/${filename}`,
          title: `dynamic-image-${index + 1}`,
        });
      });
      if (slides.length > 0) {
        slides.shift();
      }
    }
  };

  // Call the function to add dynamic slides
  addDynamicSlides();

  const containerStyles = {
    width: "90%",
    height: "60%",
    margin: "0 auto",
    
  };
  return (
      <div style={containerStyles}>
        <RportIncidentsImageSlider slides={slides} />
      </div>
  );
};

export default ReportIncidentsShowSlider;